import { useState, useEffect } from "react";
import Menu from "../../components/Menu";
import { useParams, useNavigate } from "react-router-dom";
import api from '../../apiFormData'
import Swal from 'sweetalert2'

import Clear from '../../assets/img/remove.svg'
import InputImage from "../../components/InputImage";
import InputCPF from "../../components/InputCPF";
import InputPhoneMobile from "../../components/InputPhoneMobile";
import InputDate from "../../components/InputDate";
import Validations from '../../Validations'
import LoadingBlock from "../../components/LoadingBlock";
import ModalYesNo from "../../components/ModalYesNo";
import Avatar from '../../assets/img/doctor.svg'
import FooterEdit from "../../components/FooterEdit";

import Accordion from 'react-bootstrap/Accordion';

import "./Professionals.css"
import InputPhoneMobileFull from "../../components/InputPhoneMobileFull";
import parseMaskedMoney from "../../utils/parseMaskedMoney";
import formatCurrency from "../../utils/formatCurrency";
import { Form } from "react-bootstrap";

function ProfessionalsEdit() {
    let { id } = useParams();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [error, setError] = useState({
        name: false,
        cpf: false,
        email: false,
        phoneMobile: false,
        birth: false,
        whatsappNumber: false
    })

    const [name, setName] = useState("")
    const [nickName, setNickname] = useState("")
    const [cpf, setCpf] = useState("")

    const [birth, setBirth] = useState("")
    const [email, setEmail] = useState("")
    const [phoneMobile, setPhoneMobile] = useState("")

    const [specialties, setSpecialties] = useState("")
    const [shoppers, setShoppers] = useState("")
    const [agreements, setAgreements] = useState("")

    const [councilName, setCouncilName] = useState("")
    const [councilState, setCouncilState] = useState("")
    const [councilNumber, setCouncilNumber] = useState("")

    const [isAchemed, setIsAchemed] = useState("")
    const [active, setActive] = useState("")


    const [status, setStatus] = useState("")

    const [image, setImage] = useState({
        fileReal: '',
        file: ''
    })

    const [whatsappSchedule, setWhatsappSchedule] = useState(false)
    const [whatsappNumber, setWhatsappNumber] = useState("")

    const [minutes, setMinutes] = useState(null)
    const [expense, setExpense] = useState(null)

    const onDelete = () => {
        setShowModal(false)
        setLoading(true)
        api.delete("/api/professionals/" + id).then((response) => {
            Swal.fire({
                title: "Profissional excluído com sucesso",
                icon: 'success',
                confirmButtonColor: '#3c8dbc',
            })
            setTimeout(() => {
                Swal.close()
                setTimeout(() => {
                    navigate('/professionals')
                }, 750);
            }, 1000);
        }).catch((error) => {
            console.error(error)
            Swal.fire({
                title: "Profissional não excluído",
                text: error.message,
                icon: 'error',
                confirmButtonColor: '#3c8dbc',

            })
        }).finally(() => {
            setLoading(false)
        })

    }

    const onSubmit = (ev) => {
        ev.preventDefault()
        var errors = {
            name: name.replaceAll(' ', '') === '' ? true : false,
            nickName: name.replaceAll(' ', '') === '' ? true : false,
            cpf: !Validations.CPFValid(cpf),
            email: email.replaceAll(" ", "") === "" ? false : !Validations.emailValid(email),
            phoneMobile: phoneMobile === "" ? false : !Validations.PhoneMobile(phoneMobile),
            birth: birth === "" ? false : Validations.DateDDMMAAAAInvalid(birth),
            isAchemed: (isAchemed !== true && isAchemed !== false) ? true : false,
            active: (active !== true && active !== false) ? true : false,
            //whatsappNumber: whatsappNumber === "" ? false : !Validations.PhoneMobileFull(whatsappNumber),
        }
        setError(errors)
        var validations = true

        for (const key in errors) {
            if (errors.hasOwnProperty(key) && errors[key] === true) {
                validations = false;
            }
        }

        if(whatsappSchedule && !Validations.PhoneMobileFull(whatsappNumber)){
            return Swal.fire({
                title: "Insira um número válido para agendamento via Whatsapp (ou desmarque essa opção)",
                icon: 'error',
                confirmButtonColor: '#3c8dbc',
            })
        }

        if (validations) {
            var form = new FormData()
            image.fileReal !== '' ? form.set("image", image.fileReal) : console.log('')
            form.set("id", id)
            form.set("cpf", cpf.replaceAll(".", "").replaceAll("-", ""));
            form.set("name", name);
            form.set("nick_name", nickName);
            form.set("birth", birth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3$2$1'));
            form.set("council_name", councilName);
            form.set("council_state", councilState);
            form.set("council_number", councilNumber);
            form.set("email", email.replaceAll(" ", ""));
            form.set("mobile", phoneMobile.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', ''));
            form.set("status", status)
            form.set("is_achemed", isAchemed);
            form.set("active", active);

            form.set("flag_whatsapp_scheduling", whatsappSchedule);
            form.set("whatsapp_number_scheduling", whatsappNumber.replace(/[^\d+]/g, ""));

            form.set("price_video_minutes", parseMaskedMoney(minutes))
            form.set("price_fixed_expense", parseMaskedMoney(expense))

            setLoading(true)
            api.post("/api/professionals", form).then((response) => {
                Swal.fire({
                    title: "Profissional atualizado com sucesso",
                    icon: 'success',
                    confirmButtonColor: '#3c8dbc',
                })

                setTimeout(() => {
                    Swal.close()
                    setTimeout(() => {
                        navigate('/professionals')
                    }, 750);
                }, 1000);

            }).catch((error) => {
                console.error(error)
                Swal.fire({
                    title: "Profissional não atualizado",
                    text: error.message,
                    icon: 'error',
                    confirmButtonColor: '#3c8dbc',

                })
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    useEffect(() => {
        api.get('/api/professionals/' + id).then((response) => {
            var data = response.data.data

            setImage({
                fileReal: '',
                file: response.data.data.image
            })
            setName(data.name)
            setNickname(data.nick_name);
            setEmail(data.email === null ? "" : data.email)
            setCpf(data.cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"))

            setBirth(data.birth === null ? "" : data.birth.replaceAll("-", "").replace(/^(\d{4})(\d{2})(\d{2})/, "$3/$2/$1"))
            setPhoneMobile(data.mobile === null ? "" : data.mobile.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3 - $4"))
            setCouncilName(data.council_name === null ? "" : data.council_name)
            setCouncilNumber(data.council_number === null ? "" : data.council_number)
            setCouncilState(data.council_state === null ? "" : data.council_state)
            setSpecialties(data.specialties === null ? "" : data.specialties)
            setAgreements(data.agreements === null || data.agreements === "" ? [] : data.agreements.split(/\s*;\s*/))
            setShoppers(data.shoppers)
            setStatus(data.status)
            setIsAchemed(data.is_achemed);
            setActive(data.active);

            setWhatsappSchedule(data.flag_whatsapp_scheduling)
            //setWhatsappNumber((data.whatsapp_number_scheduling === null || data.whatsapp_number_scheduling === '') ? "" : data.whatsapp_number_scheduling.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "+55 ($1) $2 $3 - $4"))
            setWhatsappNumber((data.whatsapp_number_scheduling === null || data.whatsapp_number_scheduling === '') ? "" : data.whatsapp_number_scheduling.replace(/^(\+55)(\d{2})(\d{1})(\d{4})(\d{4})$/, "$1 ($2) $3 $4 - $5"))
            
            setMinutes(formatCurrency(data.price_video_minutes))
            setExpense(formatCurrency(data.price_fixed_expense))
        }).catch((error) => {
            console.error('Error fetching professionals:', error);
        }).finally(() => {

        })
    }, [id])

    const screenTela =
        <>
            {loading && <LoadingBlock />}

            <ModalYesNo show={showModal} setShow={setShowModal} affirnName={"Deletar"} negName={"Voltar"} afirmativeFunc={onDelete} message={"Ao excluir um registro não será possivel recuperar"} title={"Tem certeza?"} imgSVG={Clear} />
            
            <form onSubmit={onSubmit}>
                <div className='screenContainer edit-mode'>
                    <h1>Profissional</h1>

                    <div className="row">
                        <h4>Dados Básicos</h4>

                        <div className="d-flex justify-content-center col-12">
                            <InputImage imageAvatar={Avatar} image={image} setImage={setImage} />
                        </div>

                        <div className="col-12 row my-2">
                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Nome*</label>
                                <input className="form-control" value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                                {error.name && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Nome Abreviado*</label>
                                <input className="form-control" value={nickName} type="text" name="nickname" placeholder="Nome" onChange={value => setNickname(value.target.value.toUpperCase())} />
                                {error.nickName && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Email*</label>
                                <input className="form-control" value={email} onChange={value => setEmail(value.target.value)} type="text" name="email" placeholder="Email" />
                            </div>
                        </div>

                        <div className="col-12 row my-2">
                            <div className="col-12 col-md-4">
                                <label className="form-label-input">CPF*</label>
                                <InputCPF value={cpf} onChange={setCpf} />
                                {error.cpf && <span className="error" >Campo Inválido</span>}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Data de Nascimento</label>
                                <InputDate value={birth} onChange={setBirth} />
                                {error.birth && <span className="error" >Campo Inválido</span>}
                            </div>
                            
                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Celular</label>
                                <InputPhoneMobile value={phoneMobile} onChange={setPhoneMobile} />
                                {error.phoneMobile && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>

                        <div className="col-12 row my-2">
                            <div className="col-12 col-md-6">
                                <label className="form-label-input">Especialidade</label>
                                <input disabled className="form-control" value={specialties} onChange={value => setSpecialties(value.target.value.toUpperCase())} type="text" name="specialties" placeholder="Especialidade" />
                            </div>

                            <div className="col-12 col-md-3 align-self-end">
                                <label className="form-label-input">Status App*</label>
                                <div>
                                    <div className="form-check form-check-inline">
                                        <input onChange={() => {
                                            setStatus("0")
                                        }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" checked={status === "0"} />
                                        <label className="form-check-label" htmlFor="inlineRadio1">Ativo</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input onChange={() => {
                                            setStatus("1")
                                        }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" checked={status === "1"} />
                                        <label className="form-check-label" htmlFor="inlineRadio2">Inativo</label>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-3 align-self-end">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="isAchemed" checked={isAchemed} onChange={() => setIsAchemed(!isAchemed)} />
                                    <label className="form-check-label" htmlFor="isAchemed">Pronto-atendimento 24h</label>
                                </div>
                                {error.isAchemed && <span className="error">Campo Inválido</span>}

                                <div className="form-check form-switch" style={{ marginTop: '10px' }}>
                                    <input className="form-check-input" type="checkbox" id="active" checked={active} onChange={() => setActive(!active)} />
                                    <label className="form-check-label" htmlFor="isAchemed">Ativo no pronto atendimento 24h</label>
                                </div>
                                {error.active && <span className="error">Campo Inválido</span>}
                            </div>
                        </div>

                        <div className="col-12 row my-2">
                            <div className="col-12 col-md-4 align-self-center">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="whatsappSchedule" checked={whatsappSchedule} onChange={() => setWhatsappSchedule(!whatsappSchedule)} />
                                    <label className="form-check-label" htmlFor="whatsappSchedule">Agendamento por Whatsapp</label>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Telefone de agendamento</label>
                                <InputPhoneMobileFull value={whatsappNumber} onChange={setWhatsappNumber} disabled={!whatsappSchedule} />
                                {error.whatsappNumber && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>

                        <div className="col-12 row my-3">
                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Minutagem (R$)</label>
                                <Form.Control
                                    name="minutes"
                                    type="text"
                                    placeholder="R$ 0,00"
                                    value={minutes}
                                    onChange={(e) => setMinutes(formatCurrency(e.target.value))}
                                />
                                {/* <input type="number" value={minutes} onChange={e => setMinutes(e.target.value)} className="form-control" name="minutes" placeholder="Minutagem" /> */}
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="form-label-input">Despesa APP (R$)</label>
                                <Form.Control
                                    name="expense"
                                    type="text"
                                    placeholder="R$ 0,00"
                                    value={expense}
                                    onChange={(e) => setExpense(formatCurrency(e.target.value))}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row row-mod-hei">
                        <h4>Dados do CRM</h4>
                        <div className="col-12 col-sm-4" >
                            <label className="form-label-input">Nome</label>
                            <input className="form-control" value={councilName} onChange={value => {
                                setCouncilName(value.target.value)
                            }} type="text" name="council_name" placeholder="CRM Sigla" />
                        </div>
                        <div className="col-12 col-sm-4">
                            <label className="form-label-input">Número</label>
                            <input className="form-control" value={councilNumber} onChange={value => {
                                var inputValue = value.target.value.replace(/[a-zA-Z]/g, '');
                                setCouncilNumber(inputValue)
                            }} type="text" name="council_number" placeholder="Número do CRM" />
                        </div>
                        <div className="col-12 col-sm-4">
                            <label className="form-label-input">Estado*</label>
                            <select name="state" value={councilState} className="form-select" onChange={value => setCouncilState(value.target.value)} >
                                <option value="" disabled >Selecione um Estado</option>
                                <option value="AC">AC</option>
                                <option value="AL">AL</option>
                                <option value="AM">AM</option>
                                <option value="AP">AP</option>
                                <option value="BA">BA</option>
                                <option value="CE">CE</option>
                                <option value="DF">DF</option>
                                <option value="ES">ES</option>
                                <option value="GO">GO</option>
                                <option value="MA">MA</option>
                                <option value="MG">MG</option>
                                <option value="MS">MS</option>
                                <option value="MT">MT</option>
                                <option value="PA">PA</option>
                                <option value="PB">PB</option>
                                <option value="PE">PE</option>
                                <option value="PI">PI</option>
                                <option value="PR">PR</option>
                                <option value="RJ">RJ</option>
                                <option value="RN">RN</option>
                                <option value="RO">RO</option>
                                <option value="RS">RS</option>
                                <option value="SC">SC</option>
                                <option value="SE">SE</option>
                                <option value="SP">SP</option>
                                <option value="TO">TO</option>
                            </select>
                        </div>
                    </div>
                    <div style={{ marginTop: '20px' }} className="row row-mod-hei">
                        <Accordion >
                            <Accordion.Item eventKey="0">
                                <Accordion.Header> <h4>Locais de atendimento</h4> </Accordion.Header>
                                <Accordion.Body>
                                    {
                                        shoppers.length === 0 ? <div><h6 style={{ textAlign: 'center', marginTop: '0px' }}>Sem locais de atendimento</h6></div> :
                                            <div className="row">
                                                {
                                                    shoppers.map((elem, index) => {
                                                        return <div key={index} style={{ padding: "0px 10px" }} className="col-12 col-sm-6 col-lg-4">
                                                            <div className="row card-shoppers-place">
                                                                <div className="col-12">
                                                                    {elem.shopper_name}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                    }
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header> <h4>Convênios</h4></Accordion.Header>
                                <Accordion.Body>
                                    {
                                        agreements.length === 0 ? <div><h6 style={{ textAlign: 'center', marginTop: '0px' }}>Sem Convênios</h6></div> :
                                            <div className="row">
                                                {
                                                    agreements.map((elem, index) => {
                                                        return <div key={index} style={{ padding: "0px 10px" }} className="col-12 col-sm-6 col-lg-4">
                                                            <div className="row card-shoppers-place">
                                                                <div  className="col-12">
                                                                    {elem}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                    }
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>

                <FooterEdit navigateRoute={"/professionals"} onClickDel={() => {
                    setShowModal(true)
                }} />
            </form>
        </>

    return (
        <Menu screen={screenTela} />
    )
}

export default ProfessionalsEdit;